import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Label, Button } from 'reactstrap';
import { update_bot_details } from '../../slices/thunks';
import Loader from '../../Components/Common/Loader';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../config';
import SimpleDonutChart from '../DragDrop/Charts/SimpleDonutChart';
import ScatterChart from '../DragDrop/Charts/ScatterChart';
import LineBarChart from '../DragDrop/Charts/LineBarChart';

function Sample_Question() {
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
  const { loading } = useSelector((state) => state.BotDetails);
  const dispatch = useDispatch();

  const [bot_sample_question, setbot_sample_question] = useState('');

  const {
    Bot_ID,
    Bot_Sample_Question,
    User_Role
  } = BotDetails || {};

  useEffect(() => {
    setbot_sample_question(Bot_Sample_Question || '');
  }, [Bot_Sample_Question]);

  const readOnly = useMemo(
    () => (User_Role === 'BotUser' || User_Role === 'Viewer'),
    [User_Role]
  );

  const onClickSave_BotConfig = () => {
    dispatch(update_bot_details({
      Bot_ID: Bot_ID,
      Bot_Sample_Question: bot_sample_question, // HTML string from TinyMCE
    }));
  };

  return (
    <>      
      <div className="mt-5">
        <div className='ws-fb' style={{ textAlign: 'right' }}>
          <Button onClick={onClickSave_BotConfig}>Save</Button>
        </div>

        <div className='sample_question_wrap border-padding'>
          {/* <Row>
            <Col xxl={12} md={12}> */}
              <div className="mt-3 calc-height">
                <Label htmlFor="botdescription" className="form-label">
                  Sample question
                </Label>

                {loading ? (
                  <Loader />
                ) : (
                  <Editor
                    id="botdescription"
                    apiKey={config.api.tiny_mce_api_key} // optional if self-hosting
                    value={bot_sample_question}
                    onEditorChange={(content) => setbot_sample_question(content)}
                    init={{
                      height: "97%",
                      resize: false,
                      menubar: false,
                      statusbar: false,
                      branding: false,
                      promotion: false,
                      readonly: readOnly,
                      plugins: [
                        'lists', 'link', 'autolink', 'code', 'wordcount', 'preview', 'searchreplace'
                      ],
                      toolbar: readOnly
                        ? 'preview | code'
                        : 'undo redo | bold italic underline | bullist numlist | link | removeformat | code',
                      placeholder: 'Write a few example questions users can click...\n• What can this bot do?\n• How do I upload a file?\n• Show me a sample query',
                      content_style:
                        'body { font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif; font-size: 14px; }'
                    }}
                  />
                )}
              </div>
            {/* </Col>
          </Row> */}
          
        </div>

      </div>
    </>
  );
}

export default Sample_Question;
